import { render } from "./verresListe.vue?vue&type=template&id=c7f2ac1c&scoped=true"
import script from "./verresListe.vue?vue&type=script&lang=js"
export * from "./verresListe.vue?vue&type=script&lang=js"

import "./verresListe.vue?vue&type=style&index=0&id=c7f2ac1c&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7f2ac1c"]])

export default __exports__